import React, { createContext, useContext } from 'react';

const MapContext = createContext();

export const useMapContext = () => {
    const context = useContext(MapContext);
    if (!context) {
        throw new Error('useMapContext must be used within a MapProvider');
    }
    return context;
};

export const useOptionalMapContext = () => {
    return useContext(MapContext) || null;
};

export const MapProvider = ({ children, mapMethods }) => (
    <MapContext.Provider value={mapMethods}>
        {children}
    </MapContext.Provider>
);
